import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./deliverable-no-mixed-campaign-content.i18n.json'));

import './deliverable-no-mixed-campaign-content.scss';

const DeliverableNoMixedCampaignContent = () => (
  <div className="deliverable-no-mixed-campaign-content__container">
    <div className="deliverable-no-mixed-campaign-content__info">
      {__t('deliverable_no_mixed_campaign_content.info')}
    </div>
    <div className="deliverable-no-mixed-campaign-content__sub-title">
      {__t('deliverable_no_mixed_campaign_content.sub_title')}
    </div>
    {
      [__t('deliverable_no_mixed_campaign_content.message_1'),
        __t('deliverable_no_mixed_campaign_content.message_2'),
        __t('deliverable_no_mixed_campaign_content.message_3')
      ].map((message) =>
        <div className="deliverable-no-mixed-campaign-content__message-point" key={message}>
          {message}
        </div>
      )
    }
  </div>
);

export default DeliverableNoMixedCampaignContent;
